import { useState } from 'react'

export function CopyButton({ text, label = '复制' }: { text: string; label?: string }) {
  const [copied, setCopied] = useState(false)
  const handleCopy = async () => {
    await navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }
  return (
    <button type="button" className="btn copy-btn btn-ghost" onClick={handleCopy}>
      {copied ? '已复制' : label}
    </button>
  )
}
